import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IHotel, IPickupLocation } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVCheckbox } from "../../shared/JVCheckbox";
import LocationAutocomplete, { NominatimResponse } from "../../shared/LocationAutoCompleteGM";

const schema = yup.object({
    hotelId: yup.number().required('Hotel is required').min(1, 'Hotel is required'),
    name: yup.string().required("Pickup Location Name is required"),
    distance: yup.number().typeError("Distance is required").required("Distance is required").min(0, "Distance is required"),
    noOfTols: yup.number().typeError("No Of Tols is required").required("No Of Tols is required").min(0, "No Of Tols is required"),
    tollCharge: yup.number().typeError("TollCharge is required").required("TollCharge is required").min(0, "TollCharge is required"),
    parkingCharge: yup.number().typeError("Parking Charge is required").required("Parking Charge is required").min(0, "Parking Charge is required"),
    desc: yup.string().nullable(),
});

interface Iprops {
    singleData: IPickupLocation,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [hotel, setHotel] = useState<IHotel>();

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<IPickupLocation>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.hotelId) loadHotelDetails(props.singleData.hotelId);
    }, [props.singleData]);

    const saveToDB = async (body: IPickupLocation) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`pickuplocation${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const loadHotelDetails = async (hotelId: number) => {
        const response = await Fetch(`hotel/${hotelId}`, 'GET', null, null, props.toast);
        if (response) {
            setHotel(await response.json());
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    function calculateDistanceByCar(
        origin: google.maps.LatLngLiteral,
        destination: google.maps.LatLngLiteral
    ) {
        const service = new google.maps.DistanceMatrixService();

        service.getDistanceMatrix(
            {
                origins: [origin],
                destinations: [destination],
                travelMode: google.maps.TravelMode.DRIVING,
            },
            (response, status) => {
                if (status === "OK" && response) {
                    const element = response.rows[0].elements[0];
                    setValue('distance', element.distance.value / 1000);
                } else { }
            }
        );
    }


    const onLocationSelect = (location?: NominatimResponse) => {
        if (!hotel) {
            props.toast.current.show({ severity: 'error', detail: 'Something went wrong!', life: 3000 });
        }
        if (location) {
            setValue('name', location.display_name);
            const locations = {
                location1: {
                    lat: hotel?.latitude ?? 0,
                    lng: hotel?.longitude ?? 0
                },
                location2: {
                    lat: Number(location.lat),
                    lng: Number(location.lng)
                }
            };
            calculateDistanceByCar(locations.location1, locations.location2);
        } else {
        }
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header="Add/Edit Pickup Location" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <LocationAutocomplete col="12" label={`Pickup Location`} onLocationSelect={onLocationSelect} countryCode="in" />
                <JVInput column={1} required label="Pickup Location" control={control} name="name" error={errors.name?.message} />
                <JVInput column={1} type="number" required label="Distance(Km)" control={control} name="distance" error={errors.distance?.message} />
                <JVInput column={1} type="number" required label="No Of Tols" control={control} name="noOfTols" error={errors.noOfTols?.message} />
                <JVInput column={1} type="number" required label="Toll Charge" control={control} name="tollCharge" error={errors.tollCharge?.message} />
                <JVInput column={1} type="number" required label="Parking Charge" control={control} name="parkingCharge" error={errors.parkingCharge?.message} />
                {props.singleData.id && <JVCheckbox column={1} label="Status" control={control} name="isActive" />}
                <JVInput column={1} label="Description" control={control} name="desc" error={errors.desc?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}